import { BaseRouteService } from 'core/services';

class FulfillmentOrderProcessingRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'fulfillment-order-processing/';
	}

	createFulfillmentShipment = (id, sourceOfChange, updateAndCreatePrintJob) => {
		return this.uriTemplateService
			.parse(
				this.base +
					'create-fulfillment-shipment/{id}/?sourceOfChange={sourceOfChange}&updateAndCreatePrintJob={updateAndCreatePrintJob}'
			)
			.expand({ id, sourceOfChange, updateAndCreatePrintJob });
	};

	createFulfillmentShipmentBulk = (sourceOfChange, updateAndCreatePrintJob) => {
		return this.uriTemplateService
			.parse(
				this.base +
					'create-fulfillment-shipment-bulk/?sourceOfChange={sourceOfChange}&updateAndCreatePrintJob={updateAndCreatePrintJob}'
			)
			.expand({ sourceOfChange, updateAndCreatePrintJob });
	};
}

export default FulfillmentOrderProcessingRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/FulfillmentOrderProcessingRouteService.js